import { render, staticRenderFns } from "./dadosDoFraction.vue?vue&type=template&id=be9a4280&"
import script from "./dadosDoFraction.vue?vue&type=script&lang=js&"
export * from "./dadosDoFraction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports